import { ProductDropdownEventListeners } from "../functions/sharedEvents";
import { ProductDropdownTemplate } from "../template/template";
import { getData } from "../functions/sharedFunctions";
export class ProductDropdownDomes {
    constructor(elem, _refs) {
        this.elem = elem;
        this._refs = { ..._refs };
        
        // Group all child items within accessory list
        // Create get data settings
        const dataSettings = {
            elem: this._refs.contentAccessory,
            dataAttribute: 'none',
            availableDataValues: ['dome']
        };
        getData(dataSettings, this.getDataResponse.bind(this));
    }

    /**
     * Create template
     * @returns {String}
     */
    createTemplate() {
        this.elem.innerHTML = this.template.createTemplate();
    }

    getDataResponse(data) {
        this._refs = {...this._refs, ...data};
        this.template = new ProductDropdownTemplate(this._refs);
        this.eventListeners = new ProductDropdownEventListeners(this.elem, this._refs);
        this.init();
    }

    init() {
        if(!this._refs.data) return;
        // create template
        this.createTemplate();
        this.eventListeners.watchEvents();
        if(this._refs.bundle) return;
        this.eventListeners.validateAddMoreFields();
    }
}